import { useContext, useEffect, useState } from 'react';

import axios from 'axios';
import { sendGTMEvent } from 'helpers/google-tag-manager';
import { MIXPANEL_EVENTS } from 'pages/leads/constants';
import useLeadsMixPanel from 'pages/leads/hooks/use-leads-mixpanel';
import { RevenueProps } from 'pages/leads/pages/revenues/revenues-page.types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import { URL_REFRESH_WEBAPP_TOKEN } from 'utils/api-urls';

import { Alert, Box, Text } from '@olist/united';

import { API_URLS } from '../../../constants';
import { RootContext } from '../../leads-provider';
import RevenuesForm from '../revenues-form/revenues-form';
import { Wrapper } from './revenues-container.style';

const RevenuesContainer = () => {
  const { t } = useTranslation();

  const {
    appUrls,
    leadIdCookie,
    leadProfileCookie,
    setLeadRevenueIdStorage,
    setLeadRevenueStorage,
    setLeadTotalFields,
  } = useContext(RootContext);
  const routeHistory = useHistory();
  const mixpanelInstance = useLeadsMixPanel();

  const [chosenRevenue, setChosenRevenue] = useState<RevenueProps | null>(null);

  const [
    { error: hasRequestError, loading: isSubmittingForm, value: requestData },
    submitQualification,
  ] = useAsyncFn(
    async (revenue) => {
      const postValues = {
        revenue: revenue.id,
      };

      setLeadTotalFields(1);
      setLeadRevenueStorage(revenue.range);
      setLeadRevenueIdStorage(revenue.id);

      sendGTMEvent('etapa_cadastro', {
        etapa: 'faturamento',
      });

      return axios.patch(API_URLS.patchRevenues, postValues);
    },
    [leadIdCookie]
  );

  useEffect(() => {
    if (hasRequestError && chosenRevenue) {
      setChosenRevenue(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasRequestError]);

  const handleRedirectAfterSubmit = async () => {
    if (!requestData) return;

    // eslint-disable-next-line
    console.log('ESTOU CHAMANDO O REFRESH TOKEN 2');
    try {
      window.location.assign(URL_REFRESH_WEBAPP_TOKEN);
    } catch (e) {
      // eslint-disable-next-line
      console.log('ERRO NO REFRESH TOKEN', e);
    }

    // const { data } = requestData as any;
    // if (data.revenue) {
    //   window.location.href = data.redirectTo || appUrls.CREATE_PASSWORD_URL;
    // }
  };

  useEffect(() => {
    handleRedirectAfterSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUrls.CREATE_PASSWORD_URL, requestData, routeHistory]);

  useEffect(() => {
    sendGTMEvent('page_view', {
      user_id: leadProfileCookie?.email,
    });
  }, [leadProfileCookie]);

  const handleSubmit = async (revenue: RevenueProps) => {
    setChosenRevenue(revenue);
    mixpanelInstance?.track(MIXPANEL_EVENTS.ANSWERED_REVENUE, { revenue });
    submitQualification(revenue);
  };

  const onChangeHandler = () => {};

  return (
    <Wrapper width={[1, 1, 1, '628px']}>
      {hasRequestError && (
        <Alert mb={3} messages={[t`ops, the form could not be submitted. Try again`]} />
      )}
      <Box maxWidth="628px">
        <Text fontSize={['19px', '31px']} mt={2} fontWeight="bold">
          {t`what is your average monthly billing?`}
        </Text>
        <Box mt={4}>
          <RevenuesForm
            onAnswer={handleSubmit}
            onChange={onChangeHandler}
            isSubmittingForm={isSubmittingForm}
          />
        </Box>
      </Box>
    </Wrapper>
  );
};

export default RevenuesContainer;
